(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcUpload', RcUpload);

    RcUpload.$inject = ['$resource', 'DateUtils'];

    function RcUpload($resource, DateUtils) {
        var resourceUrl = 'api/rc-uploads/:id';

        return $resource(resourceUrl, {}, {
            'findAllByFacility': {url: 'api/rc-uploads/by-facility/:id', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.collectedDate = DateUtils.convertLocalDateFromServer(data.collectedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.collectedDate = DateUtils.convertLocalDateToServer(copy.collectedDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.collectedDate = DateUtils.convertLocalDateToServer(copy.collectedDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
